import React from 'react';
import { Box, Button, Typography, Paper } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

interface CallToActionProps {
  title?: string;
  description?: string;
  buttonText?: string;
  buttonLink?: string;
  variant?: 'contained' | 'outlined';
}

export const CallToAction: React.FC<CallToActionProps> = ({
  title = "Ready to Get Started?",
  description = "Join GovToolsPro today and transform your government contracting process.",
  buttonText = "Get Started",
  buttonLink = "/plans",
  variant = "contained"
}) => {
  return (
    <Paper elevation={2} sx={{ p: 4, mt: 6, textAlign: 'center' }}>
      <Box sx={{ maxWidth: 800, mx: 'auto' }}>
        <Typography variant="h5" component="h2" gutterBottom>
          {title}
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          {description}
        </Typography>
        <Button
          component={RouterLink}
          to={buttonLink}
          variant={variant}
          color="primary"
          size="large"
          sx={{ mt: 2 }}
        >
          {buttonText}
        </Button>
      </Box>
    </Paper>
  );
};
